import React from 'react';
//import "bootstrap/dist/css/bootstrap.min.css";
import { observer } from 'mobx-react-lite';
import { stores } from '../store';
import { FormHelperText, makeStyles } from '@material-ui/core';
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';

const useStyles = makeStyles(theme => ({
	inputCaptcha: {
		height: '30px',
		'&:focus-visible': {
			outline: 'none',
			border: '2px solid black',
			borderRadius: '3px',
		},
	},
}));

const Captcha = observer(() => {
	const classes = useStyles();
	const appStores = React.useContext(stores.context.appStores);
	React.useEffect(() => {
		loadCaptchaEnginge(6);
	}, []);

	React.useEffect(() => {
		const handleFirstTab = (event: any) => {
			if (event.key === 'Tab') {
				document.body.classList.add('user-is-tabbing');
				window.removeEventListener('keydown', handleFirstTab);
				window.addEventListener('mousedown', handleMouseDownOnce);
			}
		};

		const handleMouseDownOnce = () => {
			document.body.classList.remove('user-is-tabbing');
			window.removeEventListener('mousedown', handleMouseDownOnce);
			window.addEventListener('keydown', handleFirstTab);
		};

		window.addEventListener('keydown', handleFirstTab);

		return () => {
			window.removeEventListener('keydown', handleFirstTab);
			window.removeEventListener('mousedown', handleMouseDownOnce);
		};
	}, []);

	React.useEffect(() => {
		const reloadButton = document.getElementById('reload_href');
		if (reloadButton) {
			reloadButton.style.color = '#098BBD';
			reloadButton.style.fontWeight = '500';
			const newParent = document.createElement('div');
			newParent.setAttribute('id', 'new_parent');
			newParent.setAttribute('class', 'new_parent');
			newParent.setAttribute('tabIndex', '0');

			newParent.style.display = 'inline-block';
			newParent.style.outline = 'none';
			newParent.style.marginBottom = '2px';

			reloadButton.parentNode?.insertBefore(newParent, reloadButton);
			newParent.appendChild(reloadButton);

			newParent.addEventListener('focus', () => {
				if (document.body.classList.contains('user-is-tabbing')) {
					newParent.style.outline = '2px solid black';
				}
			});

			newParent.addEventListener('blur', () => {
				newParent.style.outline = 'none';
			});
			newParent.addEventListener('keydown', event => {
				if (event.key === 'Enter') {
					reloadButton.click();
				}
			});
		}
	}, []);

	const doSubmit = (val: any) => {
		let user_captcha = val;
		if (validateCaptcha(user_captcha) == true) {
			appStores.captchaval = true;
			appStores.captchaerr = false;
			//		loadCaptchaEnginge(6);
		} else {
			appStores.captchaval = false;
			appStores.captchaerr = true;
		}
	};

	const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
		if (event.key === 'Enter') {
			doSubmit(event.currentTarget.value);
			if (appStores.captchaval == false) {
				event.currentTarget.value = '';
			}
		}
	};
	return (
		<div>
			<div className="container">
				<div className="form-group">
					<div className="col mt-3">
						<LoadCanvasTemplate />
					</div>
					<div className="col mt-3">
						<div>
							<input
								className={classes.inputCaptcha}
								placeholder="Enter Captcha"
								id="user_captcha_input"
								name="user_captcha_input"
								type="text"
								onBlur={e => {
									doSubmit(e.target.value);
									if (appStores.captchaval == false) {
										e.target.value = '';
									}
								}}
								onKeyDown={handleKeyDown}
							></input>
							{appStores.captchaerr === true ? (
								<FormHelperText style={{ marginTop: '5px', marginLeft: '12px', color: '#BD0810', textAlign: 'center' }}>
									Captcha not matched. Please try again.
								</FormHelperText>
							) : (
								''
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
});
export default Captcha;
